<script setup lang="ts">

import type {Car, Result, Upcoming} from "../../model/model";
import {UpcomingData} from "../../model/model";
import ReactiveItem from "../util/ReactiveItem.vue";
import UpcomingTable from "../table/UpcomingTable.vue";
import UpcomingCards from "../card/UpcomingCards.vue";

let props = defineProps<{
  news: Result<String, Array<UpcomingData>>
}>()

defineEmits(['car-select', 'trigger-sort', 'hide-upcoming'])
</script>

<template>
  <ReactiveItem>
    <template #regular>
      <UpcomingTable :upcomings="props.news"
                     @car-select="(c: Car) => $emit('car-select', c)"
                     @hide-upcoming="(u: Upcoming) => $emit('hide-upcoming', u)" />
    </template>
    <template #compact>
      <UpcomingCards :news="props.news"
                @car-select="(c: Car) => $emit('car-select', c)"
                @hide-upcoming="(u: Upcoming) => $emit('hide-upcoming', u)"/>
    </template>
  </ReactiveItem>
</template>

<style scoped>
</style>
